import { jsx as _jsx } from "react/jsx-runtime";
import { Provider } from './provider';
export const provide = ((stores, elementOrOptions) => (Component) => props => (_jsx(Provider, { ...stores, ...getOptions(elementOrOptions), children: _jsx(Component, { ...props }) })));
function getOptions(arg) {
    return arg && isOptionsObject(arg) ? arg : { loadingFallback: arg };
}
function isOptionsObject(arg) {
    return (typeof arg === 'object' &&
        (Object.hasOwn(arg, 'loadingFallback') ||
            Object.hasOwn(arg, 'errorFallback') ||
            Object.keys(arg).length === 0));
}
//# sourceMappingURL=provide.js.map